import React from "react";
import { Link } from "react-router-dom";

const ReportCard = ({
  name,
  status,
  compact = false,
  sampleUrl,     // ✅ now defined
  onTrack,       // optional
}) => {
  const isAvailable = status === "available";

  // ✅ defined in scope
  const track = (eventName, props = {}) => {
    if (typeof onTrack === "function") {
      onTrack(eventName, props);
      return;
    }
    if (typeof window !== "undefined" && window.clarity) {
      window.clarity("event", eventName, props);
    }
  };

  return (
    <div
      className={`flex flex-col items-center text-center rounded-xl shadow-md transition transform hover:scale-105 ${
        isAvailable
          ? "bg-green-50 border border-green-200"
          : "bg-gray-100 border border-gray-200 opacity-70"
      } ${compact ? "px-4 py-3" : "p-6"}`}
    >
      <h4 className={`${compact ? "text-sm" : "text-lg"} font-semibold text-gray-800`}>
        {name}
      </h4>

      <div className={`mt-3 flex items-center justify-center gap-2 ${compact ? "flex-wrap" : ""}`}>
        {/* Existing Access Now behavior */}
        {isAvailable ? (
          <Link
            to="/signup"
            onClick={() => track("report_access_click", { report: name, status })}
            className={`inline-block font-semibold rounded-full transition ${
              compact
                ? "bg-green-600 text-xs text-white px-3 py-1 hover:bg-green-700"
                : "bg-green-600 text-sm text-white px-4 py-2 hover:bg-green-700"
            }`}
          >
            {compact ? "Access Now" : "Access Report"}
          </Link>
        ) : (
          <span className={`${compact ? "text-xs" : "text-sm"} text-gray-500`}>
            Coming Soon ⏳
          </span>
        )}

        {/* ✅ Download Sample button */}
        {sampleUrl ? (
          <a
            href={sampleUrl}
            download
            onClick={() =>
              track("report_sample_download", { report: name, url: sampleUrl })
            }
            className={`inline-block font-semibold rounded-full transition border ${
              compact
                ? "text-xs px-3 py-1 border-gray-300 text-gray-800 hover:bg-gray-200"
                : "text-sm px-4 py-2 border-gray-300 text-gray-800 hover:bg-gray-200"
            }`}
          >
            Download Sample
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default ReportCard;
